import * as THREE from 'three';
import Action from '../classes/Action';
import {GroupsManager} from '../classes/GroupsManager';
import DefaultSceneManager from '../classes/DefaultSceneManager';
import Scenario from '../classes/scenarioElements/Scenario';
import { CustomEventTypes } from '../globals';
import { assert } from '../classes/utilities/ErrorHandling';

export default class RemoveFromGroupAction extends Action
{
	constructor(groupGuid: string, objects: THREE.Object3D[])
	{
		const groupName = GroupsManager.getGroupByGuid(groupGuid) ? GroupsManager.getGroupByGuid(groupGuid)!.name : "";
		const actionName = objects.length === 1 ? "Removed " + objects[0].name + " From Group " + groupName : "Removed Objects From Group " + groupName;
		const isDefaultState = Scenario.currentStep()?.isDefault();

		super([groupGuid, objects, isDefaultState],
			[groupGuid, objects, isDefaultState],
			actionName,
			[groupGuid, objects]);
	}

	do(groupGuid: string, objects: THREE.Object3D[], isDefaultState: boolean) : void
	{
		if (isDefaultState) DefaultSceneManager.getInstance().syncGroupChange(objects, groupGuid, false);

		GroupsManager.removeFromGroup(groupGuid, objects);
		document.dispatchEvent(new CustomEvent(CustomEventTypes.updatePropertiesComponent));
	}

	undo(groupGuid: string, objects: THREE.Object3D[], isDefaultState: boolean): void
	{
		if (isDefaultState)	DefaultSceneManager.getInstance().syncGroupChange(objects, groupGuid, true);

		GroupsManager.addToGroup(groupGuid, objects);
		document.dispatchEvent(new CustomEvent(CustomEventTypes.updatePropertiesComponent));
	}

	verify(groupGuid: string, objects: THREE.Object3D[]) : boolean
	{
		assert(GroupsManager.getGroupByGuid(groupGuid));

		const groupObjects = GroupsManager.getGroupObjects(groupGuid);
		for (const object of objects)
		{
			if (groupObjects.includes(object)) return true;
		}

		return false;
	}
}
